module.exports = __webpack_public_path__ + "static/media/home-service-slider-3.10a9c96c.jpg";